import {Suspense} from "react";
import {Helmet} from "react-helmet-async";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {useTable} from "@/lib/hooks/useTable.ts";
import {CreateContactAction} from "@/pages/contacts/list/actions/CreateContactAction.tsx";
import {ContactsList} from "@/pages/contacts/list/components/ContactsList.tsx";

export const ContactsPage = () => {
  const {user} = useCurrentUserContext();
  const {search, searchDebounced, searchChanged, pagination, setPagination} = useTable();

  return (
    <ContentContainer title="Contacts" actionsBar={user?.has_write_access && <CreateContactAction />}>
      <Helmet>
        <title>Contacts</title>
      </Helmet>
      <SearchInput className="mb-3" variant="tableControlBar" value={search} onChange={searchChanged} />
      <Suspense>
        <UpErrorBoundary>
          <ContactsList searchDebounced={searchDebounced} pagination={pagination} setPagination={setPagination} />
        </UpErrorBoundary>
      </Suspense>
    </ContentContainer>
  );
};
